import { pdfWorkspace } from '../../shared/api';
import { PdfConfigurations, PDF_LAYOUT_MODEL_TYPE } from '../../shared/prescriber';
import { DateFromJSDate } from '../../helpers/Date';

export const PDFService = {
  async previewDocuments(payload: PreviewDocumentsPayload): Promise<Documents> {
    const { data } = await pdfWorkspace.post(`/prescriptions/${payload.prescriptionId}/documents`, {
      isSigned: payload.isSigned,
      inSingleFile: true,
      withWatermark: true,
      showDateInPdf: payload.showDateInPdf,
      emittedTo: payload.emittedTo ? DateFromJSDate(payload.emittedTo) : null,
    });
    return data;
  },
  async layoutPdfPreview(prescriptionId: number, pdfPreviewPayload: PdfPreviewPayload): Promise<Documents> {
    const { data } = await pdfWorkspace.post(`/prescriptions/${prescriptionId}/documents`, {
      isSigned: false,
      inSingleFile: true,
      withWatermark: false,
      type: pdfPreviewPayload.type,
      isLayoutPreview: true,
      configurations: pdfPreviewPayload.configurations,
    });
    return data.documents;
  },
};

interface PreviewDocumentsPayload {
  prescriptionId: number;
  isSigned: boolean;
  showDateInPdf: boolean;
  emittedTo: Date | null;
}

interface PdfPreviewPayload {
  type: PDF_LAYOUT_MODEL_TYPE;
  configurations: PdfConfigurations | null;
}

export interface Documents {
  documents: Array<PrescriptionPDFDocument>;
}

type PrescriptionDocumentType = 'MEDICINE' | 'EXAM' | 'MEDICAL_STATEMENT' | 'SMR' | 'REFERRAL' | 'TREATMENT_SUMMARY';

export interface PrescriptionPDFDocument {
  pdfBase64?: string | null;
  html: string[];
  type: PrescriptionDocumentType;
  category: PrescriptionDocumentType;
}
